/* **A low-sleep / low-energy task's body** — the readings plot, its legend and the two tiles
 * (`docs/design/zadania-progi-2026-10-02/`, view 3). The stack, the section title and the tiles are
 * `taskBlocks`'; this file is what only this block draws.
 *
 * Blue is sleep and ember is energy (owner's series semantics, 16 September 2026), and that ink is
 * on the series, banded as the Trendy tab bands it; the average and the level are the page's own
 * ink. The legend's swatches are in that ink too: what tells a counted reading from an earlier one
 * is its SHAPE, solid or hollow, because on the plot both wear their band's colour. No fill stands
 * under a chip or a figure. */

/* The desk card's plot. On a short window — a 720p laptop once the browser's chrome is gone — it
 * takes the Talia card's shorter plot, so the counted readings, the axis under them and the tiles
 * stand in the card without scrolling. The reserve below reads the same property, so the wait and
 * the answer step down together. */
.desk { --vital-plot-height: var(--h-vital-plot); }

@media (height <= 760px) {
  .desk { --vital-plot-height: var(--h-vital-plot-quick); }
}

.head {
  display: flex;
  gap: var(--space-4);
  align-items: baseline;
  justify-content: space-between;
  min-width: 0;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-1) var(--space-3);
  justify-content: flex-end;
  font-size: var(--fs-caption);
  color: var(--text-2);
}

.legendItem {
  display: inline-flex;
  gap: var(--space-5px);
  align-items: center;
  white-space: nowrap;
}

.swatch {
  display: inline-block;
  flex: none;
  width: 8px;
  height: 8px;
  border: var(--border-ring) solid var(--text-2);
  border-radius: var(--r-circle);
}

.swatchCounted { background: var(--text-2); }

.rule {
  display: inline-block;
  flex: none;
  width: 14px;
}

.ruleMean { border-top: var(--border-focus) solid var(--text); }
.ruleLevel { border-top: var(--border-ring) dashed var(--text-2); }

/* The reading's own box: the plot and the tiles under it, one fixed height from the first frame, so
 * the read changes ink and never geometry. */
.readingBox {
  height: calc(var(--vital-plot-height) + var(--space-3) + var(--h-vital-tiles));
  min-width: 0;
}

.reading {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}

.reserveDesk { height: 100%; }

/* The Talia card: the plot is the whole body, centred in it. */
.readingQuick {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  min-height: var(--h-vital-plot-quick);
}

.reserveQuick { height: var(--h-vital-plot-quick); }

/* Two facts, at the tiles' own quarter width: nothing is stretched to fill the row. */
.tiles {
  height: var(--h-vital-tiles);
}
